import { render, staticRenderFns } from "./AddPerson.vue?vue&type=template&id=933961f8&scoped=true&"
import script from "./AddPerson.vue?vue&type=script&lang=js&"
export * from "./AddPerson.vue?vue&type=script&lang=js&"
import style0 from "./AddPerson.vue?vue&type=style&index=0&id=933961f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933961f8",
  null
  
)

export default component.exports